module.exports = __webpack_public_path__ + "img/apple.3bb2215d.png";